import React, { PureComponent } from 'react'

// local components
import ReportingBroadcastItem from './ReportingBroadcastItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const ReportingBroadcastItemEditable = EditableHOCWrapper(ReportingBroadcastItem)

class ReportingBroadcastContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    const { isNewBroadcast = false } = this.props
    if (isNewBroadcast) {
      this.props.createBroadcast(data, afterOnSave)
    } else {
      this.props.updateBroadcast(data, afterOnSave)
    }
  }

  render() {
    const { broadcast = {}, defaultEditMode = false, onCancel, onDelete, shops } = this.props

    return (
      <ReportingBroadcastItemEditable
        dataToEdit={broadcast}
        onSave={this.onSave}
        defaultEditMode={defaultEditMode}
        shops={shops}
        onCancel={onCancel}
        onDelete={onDelete}
        {...this.props}
      />
    )
  }
}

export default ReportingBroadcastContainer



// WEBPACK FOOTER //
// ./src/components/Insights/ReportingBroadcastContainer.js